export default "__VITE_ASSET__CRG83JfM__"